import React from "react";
import { useSelector } from "react-redux";

import { getPumpDischargeChart } from "../state/selectedAsset";
import { Asset } from "../types/assets";

import TimeseriesDischargeChart from "./TimeseriesDischargeChart";

interface Props {
  asset: Asset;
}

const TimeseriesPumpDischargeChart: React.FC<Props> = (props) => {
  const pumpDischargeGraph = useSelector(getPumpDischargeChart);
  const { asset } = props;

  return <TimeseriesDischargeChart asset={asset} dichargeGraph={pumpDischargeGraph} />;
};

export default TimeseriesPumpDischargeChart;
